<template>
  <div class="container box" id="container-main">
    <div class="row" id="main-row">
      <div id="vapp">
        <div class="header">
          <h1 class="title">Modules</h1>
          <div class="buttonsGroup">
            <b-tooltip label="Add a Module" position="is-bottom"
              ><button class="button is-medium is-success" @click="isNewItemActive = true">
                <b-icon icon="plus" size="is-small"></b-icon>
              </button>
            </b-tooltip>
            <b-tooltip label="Edit a Module" position="is-bottom"
              ><button class="button is-medium is-warning" @click="EditItem()">
                <b-icon icon="pencil" size="is-small"></b-icon>
              </button>
            </b-tooltip>
            <b-tooltip label="Delete a Module" position="is-left"
              ><button class="button is-medium is-danger" @click="DeleteItem()">
                <b-icon icon="trash" size="is-small"></b-icon>
              </button>
            </b-tooltip>
          </div>
        </div>
        <template>
          <b-table :data="this.modules" :selected.sync="selected" :loading="this.isLoading" hoverable sticky-header>
            <b-table-column field="module_id" label="Module ID" sortable v-slot="props">
              {{ props.row.module_id }}
            </b-table-column>
            <b-table-column field="module_name" label="Module Name" sortable v-slot="props">
              {{ props.row.module_name }}
            </b-table-column>
            <b-table-column field="context_name" label="Context Name" sortable v-slot="props">
              {{ props.row.context_name }}
            </b-table-column>
            <b-table-column field="hidden" label="Hidden" sortable v-slot="props">
              <b-checkbox v-model="props.row.hidden" true-value="1" false-value="0" @input="UpdateItem(props.row)"></b-checkbox>
            </b-table-column>
            <b-table-column field="bookable" label="Bookable" sortable v-slot="props">
              <b-checkbox v-model="props.row.bookable" true-value="1" false-value="0" @input="UpdateItem(props.row)"></b-checkbox>
            </b-table-column>
          </b-table>
        </template>
        <b-modal :active.sync="isNewItemActive" has-modal-card trap-focus :destroy-on-hide="false" aria-role="dialog" aria-modal>
          <new-module @submitted="AddNewItem" :item="this.formProps"></new-module>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
const NewModule = {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  template: `
        <form @submit.prevent="">
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">Add Module</p>
                </header>
                <section class="modal-card-body">
                    <b-field label="Module Name">
                        <b-input type="text" v-model="item.module_name"></b-input>
                    </b-field>
                    <b-field label="Description">
                        <b-input type="text" v-model="item.description"></b-input>
                    </b-field>
                    <b-field label="Context Name">
                        <b-input type="text" v-model="item.context_name"></b-input>
                    </b-field>
                </section>
                <footer class="modal-card-foot">
                    <button class="button" type="button" @click="$parent.close()">Cancel</button>
                    <button class="button is-primary" @click="$emit('submitted')">Submit</button>
                </footer>
            </div>
        </form>
        `,
};

const axios = require("axios");
export default {
  components: {
    NewModule,
  },
  data: function () {
    return {
      modules: [],
      selected: {},
      isLoading: true,
      isNewItemActive: false,
      formProps: {},
      newApiUrl: "https://api.jeak.co.uk",
    };
  },
  methods: {
    GetItems: async function () {
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: `Bearer ` + token },
      };
      axios
        .get(this.newApiUrl + "/modules", config)
        .then((response) => {
          this.modules = response.data;
          this.isLoading = false;
        })
        .catch((error) => {
          this.$buefy.snackbar.open({
            message: "An error occurred! If this persists, please contact support",
            type: "is-danger",
            position: "is-top",
          });
          console.error(error.message);
        });
    },
    EditItem: function () {
      if (Object.entries(this.selected).length === 0) {
        this.$buefy.snackbar.open({
          message: "Please select an item to edit first!",
          type: "is-warning",
          position: "is-top",
        });
      } else {
        this.$router.push({ path: "edit-module", query: { module: this.selected.module_id } });
      }
    },
    DeleteItem: function () {
      if (Object.entries(this.selected).length === 0) {
        this.$buefy.snackbar.open({
          message: "Please select an item to delete first!",
          type: "is-warning",
          position: "is-top",
        });
      } else {
        this.$buefy.dialog.confirm({
          title: "Deleting Module",
          message: `Are you sure you want to <b>delete</b> ${this.selected.module_name}? No backsies!`,
          confirmText: "Delete Module",
          type: "is-danger",
          hasIcon: true,
          onConfirm: async () => {
            const token = await this.$cognitoAuth.getIdToken();
            const config = {
              headers: { Authorization: `Bearer ` + token },
            };
            axios
              .delete(this.newApiUrl + `/modules/${this.selected.module_id}`, config)
              .then((response) => {
                if (response.status == 200) {
                  this.$buefy.toast.open("Module deleted!");
                  this.SendNotification(`${this.$route.params.name} deleted Module ${this.selected.module_name}`, "error");
                  this.GetItems();
                } else {
                  this.$buefy.snackbar.open({
                    message: "An error occurred! If this persists, please contact support",
                    type: "is-danger",
                    position: "is-top",
                  });
                }
              })
              .catch((error) => {
                this.$buefy.snackbar.open({
                  message: "An error occurred! If this persists, please contact support",
                  type: "is-danger",
                  position: "is-top",
                });
                console.error(error);
              });
          },
        });
      }
    },
    AddNewItem: async function () {
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: `Bearer ` + token },
      };
      if (!this.formProps.description) this.formProps.description = "";
      axios
        .post(this.newApiUrl + `/modules`, this.formProps, config)
        .then(() => {
          this.$buefy.toast.open({
            message: "Great Success",
            type: "is-success",
          });
          this.isNewItemActive = false;
        })
        .catch((error) => {
          this.$buefy.toast.open({
            message: "An error occurred! If this persists, please contact support",
            type: "is-danger",
          });
          console.error(error);
        });
    },
    UpdateItem: async function (module) {
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: `Bearer ` + token },
      };

      axios.put(this.newApiUrl + `/modules/${module.module_id}`, module, config).then(() => {});
    },
    HasGroup: function (groups = []) {
      if (!(this.$route && this.$route.params && Array.isArray(this.$route.params.groups))) return false;
      const userGroups = this.$route.params.groups.map((group) => String(group).toLowerCase());
      for (const group of groups) {
        if (userGroups.includes(String(group).toLowerCase())) return true;
      }

      return false;
    },
    SendNotification: async function (message, type) {
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: "Bearer " + token },
      };
      const body = {
        message: message,
        type: type,
      };
      axios.post(this.newApiUrl + "/notification", body, config);
    },
  },
  mounted() {
    this.GetItems();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.container {
  margin-top: 20px;
}
#vapp {
  display: grid;
  grid-template-rows: 1fr;
}
.header {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
}
.header h1 {
  grid-column: 1/6;
}
.buttonsGroup {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
}
.b-table {
  height: 100%;
  max-height: 650px;
}
</style>
